// extracted by mini-css-extract-plugin
module.exports = {"positive":"styles_positive__2B2OX","negative":"styles_negative__2-Z8c"};